const defaultConfig = {
  favorites: [],
  lastVisited: [],
  langEng: false,
  showEditorStyling: false,
  editorFontSize: 1.2,
  lightTheme: true
};

export default class ProfileConfig {
  constructor(settings) {
    let store = settings || defaultConfig;
    try {
      const fromStore = JSON.parse(localStorage.getItem('profile'));
      if (fromStore) store = fromStore;
    } catch (err) {
      console.log(err);
    }
    Object.assign(this, store);
  }

  save() {
    let toStore = Object.assign({}, this);
    localStorage.setItem('profile', JSON.stringify(toStore));
  }

  clear() {
    delete localStorage.profile;
  }
}
